import environmentConfig from '../config/environment';

let registry = null;
let lastFetched = null;
const CACHE_TTL = 30 * 60 * 1000; // 30 minutes

export const companyService = {
  async fetchRegistry() {
    const now = Date.now();
    if (registry && lastFetched && now - lastFetched < CACHE_TTL) {
      return registry;
    }

    const url = environmentConfig.REGISTRY_URL;
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch company registry: ${response.statusText}`);
    }

    registry = await response.json();
    lastFetched = now;
    return registry;
  },

  async resolveCompany(code) {
    if (!code) return null;
    const reg = await this.fetchRegistry();
    return reg[code.toLowerCase()] || null;
  },

  clearCache() {
    registry = null;
    lastFetched = null;
  }
};

export default companyService;
